export enum PluralCategory {
  One = 'one',
  Few = 'few',
  Many = 'many',
  Other = 'other',
}
